import React from 'react'

const Colombia = () => {
  return (
    <div>
      Colombia
    </div>
  )
}

export default Colombia
